import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { IndicadoresPgAnaliseService } from "../services/indicadores-pg-analise.service";


@Injectable({
  providedIn: 'root'
})
export class IndicadoresPgAnaliseResolver implements Resolve<boolean> {

  constructor(private service: IndicadoresPgAnaliseService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class IndicadoresPgAnaliseListResolver implements Resolve<boolean> {

  constructor(private service: IndicadoresPgAnaliseService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByListForm();
  }
}